module.exports = __webpack_public_path__ + "img/icon_expand.90820940.svg";